import React from "react";
import styles from "./descriptionTile.module.scss";

const DescriptionTile = ({product}) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{product?.tittle || "NA"}</div>
      <div className={styles.description}>
        {product?.description || "No description"}
      </div>
      {/* <div className={styles.keypoint}> {product.keypoint || "100% natural" }</div>
      <div className={styles.keypoint}>{product.keypoint ||"High in calcium and protein"}</div>
      <div className={styles.keypoint}>{product.keypoint ||"Lactose-friendly and easy to digest"}</div> */}
    </div>
  );
};

export default DescriptionTile;
